/* eslint-disable react/jsx-curly-newline */
import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useParams, useHistory } from 'react-router-dom';
import {
  CRow,
  CCol,
  CCard,
  CCardHeader,
  CCardBody,
  CCardFooter,
  CFormGroup,
  CLabel,
  CInput,
  CButton,
  CForm,
  CInputCheckbox,
  CInputFile,
  CTextarea,
} from '@coreui/react';
import { useDispatch, useSelector } from 'react-redux';

import 'react-confirm-alert/src/react-confirm-alert.css';
import apiClient from 'src/api/api-client';
import { uploadFileURI } from 'src/api';
import { detailService, upsertService } from 'src/slices/ServiceSlice';
import { resetData } from 'src/slices/ServiceItemSlice';
import { useTrans } from 'src/contexts/language';

const ServiceDetail = () => {
  const { t, language } = useTrans();
  const routeParams = useParams();
  const { id } = routeParams;
  const [openModalProject, setOpenModalProject] = useState(false);
  const [selectedLogo, setSelectedLogo] = useState();
  const [selectedImage, setSelectedImage] = useState();
  const serviceItem = useSelector(state => state.serviceItem);
  const dispatch = useDispatch();
  const history = useHistory();
  const [validated, setValidated] = useState(false);

  const formik = useFormik({
    initialValues: {
      language,
      title_vi: serviceItem.title_vi || '',
      title_en: serviceItem.title_en || '',
      title_jp: serviceItem.title_jp || '',
      subtitle_vi: serviceItem.title_vi || '',
      subtitle_en: serviceItem.title_en || '',
      subtitle_jp: serviceItem.title_jp || '',
      description_vi: serviceItem.description_vi || '',
      description_en: serviceItem.description_en || '',
      description_jp: serviceItem.description_jp || '',
      status: serviceItem.status || 0,
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      title_vi: Yup.string().required(`${t('Vui lòng điền')} ${t('Tiêu đề tiếng')} ${t('Việt')}`),
      subtitle_vi: Yup.string().required(
        `${t('Vui lòng điền')} ${t('Mô tả ngắn tiếng')} ${t('Việt')}`,
      ),
      description_vi: Yup.string().required(
        `${t('Vui lòng điền')} ${t('Mô tả tiếng')} ${t('Việt')}`,
      ),
    }),
    onSubmit: async vals => {
      let { image, logo } = serviceItem;
      if (selectedImage) {
        const uploadFormData = new FormData();
        uploadFormData.append('file', selectedImage);
        const uploadRes = await apiClient.handleRequest({
          method: 'post',
          url: `${uploadFileURI}`,
          data: uploadFormData,
        });
        image = uploadRes.data.data;
      }
      if (selectedLogo) {
        const uploadFormData = new FormData();
        uploadFormData.append('file', selectedLogo);
        const uploadRes = await apiClient.handleRequest({
          method: 'post',
          url: `${uploadFileURI}`,
          data: uploadFormData,
        });
        logo = uploadRes.data.data;
      }

      const res = await dispatch(
        upsertService({
          id: id === 'create' ? '' : id,
          data: { ...vals, image },
        }),
      );
      if (res.payload === true) {
        history.push(`/service`);
      }
    },
  });
  const {
    handleSubmit,
    handleChange,
    handleBlur,
    touched,
    setFieldValue,
    values, // use this if you want controlled components
    errors,
    initialValues,
  } = formik;
  const imageChange = e => {
    setSelectedImage(e.target.files[0]);
  };
  const logoChange = e => {
    setSelectedLogo(e.target.files[0]);
  };

  const setData = (name, value) => {
    setFieldValue(name, value);
  };

  const handleClean = e => {
    e.preventDefault();
    dispatch(resetData());
    setSelectedImage();
    history.push(`/service`);
  };

  useEffect(() => {
    (async () => {
      if (id !== 'create') {
        await dispatch(detailService(id));
      } else {
        dispatch(resetData());
        setSelectedImage();
      }
    })();
  }, [id]);

  return (
    <>
      <CForm
        action=""
        method="post"
        encType="multipart/form-data"
        className="form-horizontal"
        onSubmit={handleSubmit}
      >
        <CCard>
          <CCardHeader>{t('Tạo mới dịch vụ')}</CCardHeader>
          <CCardBody>
            <CRow>
              <CCol xs="6">
                <CFormGroup>
                  <CLabel htmlFor="image">{t('Tải')} image</CLabel>
                  <CFormGroup variant="custom-checkbox">
                    <CInputFile
                      custom
                      id="image"
                      onChange={e => {
                        imageChange(e);
                      }}
                      accept="image/*"
                    />
                    <CLabel htmlFor="image" variant="custom-file">
                      {selectedImage?.name || t('Chọn file')}
                    </CLabel>
                  </CFormGroup>
                </CFormGroup>
              </CCol>
              <CCol xs="6">
                {selectedImage && (
                  <div>
                    <img
                      style={{ width: '-webkit-fill-available' }}
                      src={URL.createObjectURL(selectedImage)}
                      alt=""
                    />
                  </div>
                )}
                {!selectedImage && serviceItem.image && (
                  <div>
                    <img
                      style={{ width: '-webkit-fill-available' }}
                      src={serviceItem.image}
                      alt=""
                    />
                  </div>
                )}
              </CCol>
            </CRow>
            <CRow>
              <CCol xs="6">
                <CFormGroup>
                  <CLabel htmlFor="title_vi">
                    {t('Tiêu đề tiếng')} {t('Việt')}
                  </CLabel>
                  <CInput
                    id="title_vi"
                    name="title_vi"
                    onChange={e => setData(e.target.name, e.target.value)}
                    value={values.title_vi || ''}
                  />
                  {touched.title_vi && errors.title_vi ? (
                    <small className="text-danger">{t(errors.title_vi)}</small>
                  ) : null}
                </CFormGroup>
              </CCol>
              <CCol xs="6">
                <CFormGroup>
                  <CLabel htmlFor="title_en">
                    {t('Tiêu đề tiếng')} {t('Anh')}
                  </CLabel>
                  <CInput
                    id="title_en"
                    name="title_en"
                    onChange={e => setData(e.target.name, e.target.value)}
                    value={values.title_en || ''}
                  />
                  {touched.title_en && errors.title_en ? (
                    <small className="text-danger">{t(errors.title_en)}</small>
                  ) : null}
                </CFormGroup>
              </CCol>
              <CCol xs="6">
                <CFormGroup>
                  <CLabel htmlFor="title_jp">
                    {t('Tiêu đề tiếng')} {t('Nhật')}
                  </CLabel>
                  <CInput
                    id="title_jp"
                    name="title_jp"
                    onChange={e => setData(e.target.name, e.target.value)}
                    value={values.title_jp || ''}
                  />
                  {touched.title_jp && errors.title_jp ? (
                    <small className="text-danger">{t(errors.title_jp)}</small>
                  ) : null}
                </CFormGroup>
              </CCol>
            </CRow>
            <CRow>
              <CCol xs="6">
                <CFormGroup>
                  <CLabel htmlFor="subtitle_vi">
                    {t('Mô tả ngắn tiếng')} {t('Việt')}
                  </CLabel>
                  <CInput
                    id="subtitle_vi"
                    name="subtitle_vi"
                    onChange={e => setData(e.target.name, e.target.value)}
                    value={values.subtitle_vi || ''}
                  />
                  {touched.subtitle_vi && errors.subtitle_vi ? (
                    <small className="text-danger">{t(errors.subtitle_vi)}</small>
                  ) : null}
                </CFormGroup>
              </CCol>
              <CCol xs="6">
                <CFormGroup>
                  <CLabel htmlFor="subtitle_en">
                    {t('Mô tả ngắn tiếng')} {t('Anh')}
                  </CLabel>
                  <CInput
                    id="subtitle_en"
                    name="subtitle_en"
                    onChange={e => setData(e.target.name, e.target.value)}
                    value={values.subtitle_en || ''}
                  />
                  {touched.subtitle_en && errors.subtitle_en ? (
                    <small className="text-danger">{t(errors.subtitle_en)}</small>
                  ) : null}
                </CFormGroup>
              </CCol>
              <CCol xs="6">
                <CFormGroup>
                  <CLabel htmlFor="subtitle_jp">
                    {t('Mô tả ngắn tiếng')} {t('Nhật')}
                  </CLabel>
                  <CInput
                    id="subtitle_jp"
                    name="subtitle_jp"
                    onChange={e => setData(e.target.name, e.target.value)}
                    value={values.subtitle_jp || ''}
                  />
                  {touched.subtitle_jp && errors.subtitle_jp ? (
                    <small className="text-danger">{t(errors.subtitle_jp)}</small>
                  ) : null}
                </CFormGroup>
              </CCol>
            </CRow>
            <CRow>
              <CCol xs="6">
                <CFormGroup>
                  <CLabel htmlFor="description_vi">
                    {t('Nội dung tiếng')} {t('Việt')}
                  </CLabel>
                  <CTextarea
                    id="description_vi"
                    name="description_vi"
                    onChange={e => setData(e.target.name, e.target.value)}
                    value={values.description_vi || ''}
                    rows={4}
                  />
                  {touched.description_vi && errors.description_vi ? (
                    <small className="text-danger">{t(errors.description_vi)}</small>
                  ) : null}
                </CFormGroup>
              </CCol>
              <CCol xs="6">
                <CFormGroup>
                  <CLabel htmlFor="description_en">
                    {t('Nội dung tiếng')} {t('Anh')}
                  </CLabel>
                  <CTextarea
                    id="description_en"
                    name="description_en"
                    onChange={e => setData(e.target.name, e.target.value)}
                    value={values.description_en || ''}
                    rows={4}
                  />
                  {touched.description_en && errors.description_en ? (
                    <small className="text-danger">{t(errors.description_en)}</small>
                  ) : null}
                </CFormGroup>
              </CCol>
              <CCol xs="6">
                <CFormGroup>
                  <CLabel htmlFor="description_jp">
                    {t('Nội dung tiếng')} {t('Nhật')}
                  </CLabel>
                  <CTextarea
                    id="description_jp"
                    name="description_jp"
                    onChange={e => setData(e.target.name, e.target.value)}
                    value={values.description_jp || ''}
                    rows={4}
                  />
                  {touched.description_jp && errors.description_jp ? (
                    <small className="text-danger">{t(errors.description_jp)}</small>
                  ) : null}
                </CFormGroup>
              </CCol>
            </CRow>

            <CRow>
              <CCol xs="4">
                <CFormGroup variant="custom-checkbox" inline>
                  <CInputCheckbox
                    id="status"
                    name="status"
                    checked={values.status ? 1 : 0}
                    onChange={e => setData(e.target.name, values.status ? 0 : 1)}
                  />
                  <CLabel htmlFor="status">{t('Kích hoạt')}</CLabel>
                </CFormGroup>
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter align="center">
            <CButton color="primary" style={{ marginRight: 10 }} type="submit">
              {t('Lưu')}
            </CButton>
            <CButton color="secondary" onClick={handleClean}>
              {t('Không')}
            </CButton>
          </CCardFooter>
        </CCard>
      </CForm>
      <style>
        {`
          .horizontal-slider {
            width: 100%;
            max-width: 700px;
            height: 10vh;
            margin: auto;
          }
          .horizontal-text {
            max-width: 700px;
            width: 100%;
            margin: auto;
            display: flex;
            justify-content: space-between;
          }
          .horizontal-text div {
            text-align: center;
          }
          .horizontal-text p {
            background-color: #fca432;
            padding: 7px;
            color: white;
            border-radius: 15px;
          }
          .example-thumb {
            cursor: pointer;
            position: absolute;
            z-index: 100;
            background: #ffffff;
            border: 5px solid #fca432;
            border-radius: 100%;
            display: block;
            box-shadow: 0 0 2px 0 rgb(0 0 0 / 44%);
          }
          .example-thumb.active {
            background-color: grey;
          }
          .example-track {
            position: relative;
            background: #ddd;
          }
          .example-track.example-track-0 {
            background: #fca432;
          }
          .horizontal-slider .example-track {
            top: 15px;
            height: 5px;
          }
          .horizontal-slider .example-thumb {
            top: 12px;
            width: 10px;
            outline: none;
            height: 10px;
            line-height: 38px;
          }
        `}
      </style>
    </>
  );
};

export default ServiceDetail;
